// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"747":"react-lottie-player","900":"animations"}[chunkId] || chunkId) + "." + {"747":"909d8136","787":"0b0582da","900":"f4529552"}[chunkId] + ".chunk.js";
};